import styled from 'styled-components';

export const ProjectItemWrapper = styled.div`
  cursor: pointer;
  .--pjStats {
    color: #969fa7;

    li {
      margin-right: 0.5rem;

      i {
        margin-right: 4px;
      }
    }
  }

  .--pjTitle {
    // font-size: 16px;
    font-size: inherit;
    margin: 0;
    font-weight: 600;
    line-height: 140%;
  }

  .--pjImg {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .--pjShortDesc {
    font-size: 0.85rem;
    color: var(--color-grey-3);
    margin-bottom: 1rem;
    display: -webkit-box;
    // max-width: 200px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &.projectStyle-4 {
    position: relative;
    height: 220px;
    width: calc(25% - 12px);
    display: flex;
    align-items: flex-end;
    .--pjInfo {
      z-index: 2;
      color: #fff;
      width: 100%;
      padding: 16px 12px 0;
      transition: var(--transition-regular);
    }
    .--pjTitle {
      font-weight: initial;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      padding: 8px 0;
    }
    .--pjStats {
      position: absolute;
      top: 0;
      right: 0;
      li {
        margin: 0 0 0 1px;
        display: flex;
        font-size: 13px;
        align-items: center;
        color: #fff;
        padding: 6px;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }
    }
    .--pjShortDesc {
      display: none;
    }
    .--pjImg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      // opacity: 0.75;
    }
    &:hover {
      .--pjInfo {
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), transparent);
      }
    }
    @media (max-width: 768px) {
      width: 50% !important;
      margin-right: -6px;
      margin-bottom: -6px;
      .--pjInfo {
        // background: rgba(0, 0, 0, 0.5);
      }
    }
  }

  &.projectStyle-1 {
    border: 1px solid #ddd;
    border-radius: 6px;
    overflow: hidden;
    width: calc(25% - 12px);
    display: flex;
    flex-flow: column;
    transition: var(--transition-smooth);
    position: relative;

    &:hover {
      transform: translateY(-0.35rem);
      box-shadow: 0 12px 24px rgb(0 0 0 / 8%);
      border-color: transparent;
    }

    .--pjInfo {
      padding: 16px;
      order: 1;
      flex: 1;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
    }

    .--pjTitle {
      // margin-bottom: 12px;
    }

    .--pjStats {
      position: absolute;
      top: 8px;
      right: 0;
      li {
        color: #fff;
        padding: 2px 10px;
        border-radius: 25px;
        background: rgba(0, 0, 0, 0.5);
      }
    }

    .--pjShortDesc {
      margin: 0;
    }

    .--pjImg {
      width: 100%;
      // height: 200px;
      img {
        width: 100%;
        height: auto;
        aspect-ratio: 1.5;
      }
    }

    .--pjStats {
    }
    // &:last-child {}

    @media (min-width: 1400px) {
      width: calc(20% - 14px);
    }

    @media (max-width: 768px) {
      width: 100%;
      .--pjImg {
        img {
          aspect-ratio: 2;
        }
      }
    }
  }

  &.projectStyle-2 {
    display: flex;
    flex-flow: column-reverse;
    justify-content: flex-end;
    position: relative;
    width: calc(25% - 12px);

    .--pjImg {
      width: 100%;
      height: 132px;
      border-radius: 8px;
      overflow: hidden;
      position: relative;
      transition: var(--transition-smooth);
      &::after {
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 64.68%,
          rgba(0, 0, 0, 0.75) 100%
        );
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    }

    .--pjInfo {
      // border: 1px solid #dadada;
      background: #eee;
      border-radius: 0 0 12px 12px;
      padding: 16px;
      width: 94%;
      margin: -4px auto 0;
      position: relative;
      flex: 1;
      transition: var(--transition-smooth);
    }

    .--pjTitle {
      // margin-bottom: 8px;
    }

    .--pjStats {
      position: absolute;
      top: -24px;
      z-index: 1;
      left: 50%;
      transform: translate(-50%, 0);
      color: #fff;
      width: 100%;
      ul {
        width: 100%;
        justify-content: center;
      }
    }

    .--pjShortDesc {
      margin: 4px 0 0 0;
    }

    &:hover {
      .--pjInfo {
        border: 1px solid #eee;
        background: #fff;
        box-shadow: 0 2px 6px rgb(0 0 0 / 8%);
      }
      .--pjImg {
        transform: translateY(-4px) scale(1.03);
        box-shadow: 0 6px 8px rgb(0 0 0 / 20%);
      }
    }

    @media (max-width: 768px) {
      width: calc(100% + 30px);
      flex: 0 0 auto;
      margin-left: -15px;
      .--pjInfo {
        background: transparent;
        width: 100%;
        padding: 16px;
        border-radius: 0 !important;
        border: none !important;
        box-shadow: none !important;
      }
      .--pjImg {
        box-shadow: none !important;
        transform: none !important;
        border-radius: 0;
      }
    }

    @media (min-width: 1400px) {
      width: calc(20% - 14px);
    }
  }

  &.projectStyle-3 {
    display: flex;
    flex-flow: row-reverse;
    padding: 12px;
    // border: 1px solid #dadada;
    // box-shadow: 0px 4px 12px rgb(0 0 0 / 4%);
    // background: #eee;
    border-radius: 12px;
    gap: 24px;
    width: calc(50% - 12px);
    position: relative;
    &:after {
      content: '';
      border: 1px solid transparent;
      position: absolute;
      z-index: 0;
      width: calc(100%);
      height: calc(100%);
      top: 0;
      left: 0;
      border-radius: 12px;
      background: #eee;
      transition: all 0.15s ease-out,
        transform 0.5s cubic-bezier(0.23, 2.08, 0.6, 0.97);
    }
    .--pjImg {
      width: 50%;
      border-radius: 8px;
      overflow: hidden;
      height: 132px;
      z-index: 1;
      position: relative;
    }

    .--pjInfo {
      width: 50%;
      text-align: center;
      padding: 8px 0;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      z-index: 1;
      position: relative;
    }

    .--pjShortDesc {
      flex: 1;
    }

    .--pjStats {
      display: flex;
      justify-content: center;
    }

    .--pjTitle {
      margin-bottom: 4px;
    }

    .pjStats {
      position: absolute;
    }

    &:hover {
      &:after {
        transform: scale(1.02);
        background: #fff;
        border-color: #ddd;
        box-shadow: 0px 4px 12px rgb(0 0 0 / 4%);
      }
    }

    @media (min-width: 1400px) {
      width: calc(33.333% - 12px);
    }

    @media (max-width: 768px) {
      padding: 12px;
      width: calc(50% - 4px);
      flex-flow: column-reverse;
      gap: 12px;
      justify-content: flex-end;

      .--pjInfo {
        width: 100%;
        padding: 0;
        flex: 1;
      }

      .--pjImg {
        width: 100%;
        height: 110px;
      }

      .--pjStats {
        position: relative;
        bottom: unset;
        transform: none;
        left: unset;

        ul {
          margin-top: 8px;
          justify-content: center;
        }
      }
    }
  }
`;

export const HeaderWrapper = styled.div`
  .portBanner {
    &.headerStyle-4 {
      position: fixed;
      top: 0;
      width: 100%;
      .--logo {
        left: 4rem;
      }
      .--img {
        max-height: 80vh;
        min-height: 76vh;
      }
      @media (max-width: 768px) {
        height: 320px;
        .--logo {
          left: 1rem;
        }
        .--img {
          min-height: 300px;
        }
      }
    }
    &.headerStyle-1 {
      .--img {
        height: 240px;
      }

      .portContact {
        padding-top: 1.5rem;
      }

      .portProfile {
        margin-top: -82px;

        .--info {
          padding-top: 100px;
        }

        .--name {
          margin-bottom: 0;
        }

        .--locale {
        }

        .--avatar {
          margin-right: 1rem;
        }
      }

      .portMenu {
        margin: 2rem 0;

        ul {
          border-top: 1px solid #ddd;
          padding-top: 1rem;
          flex-wrap: wrap;
          gap: 8px;
        }
      }

      @media (max-width: 768px) {
        .portProfile {
          margin-top: -60px;
          position: relative;

          .--avatar {
            width: 120px;
            height: 120px;
            flex: 0 0 auto;
          }

          .--info {
            padding-top: 80px;
          }
        }

        .portMenu {
          ul {
            flex-wrap: inherit;
            overflow-y: hidden;
            overflow-x: auto;
            padding-bottom: 1rem;
          }
        }

        .itemPortMenu {
        }

        .portContact {
          position: absolute;
          top: 0;
          right: 0;
          padding-top: 0.5rem;
        }
      }
    }

    &.headerStyle-2 {
      .portInfo {
        position: relative;
      }

      .--img {
        height: 460px;
        // filter: grayscale(1);
      }

      .portProfile {
        padding: 30px 0;

        .--locale {
          color: #fff;
        }

        .--avatar {
          width: 90px;
          height: 90px;
        }

        .--info {
          color: var(--color-text);
          text-align: center;
        }

        .portContact {
          margin: 0.75rem 0;

          ul {
            justify-content: center;
          }
        }
      }

      .--content {
        position: absolute;
        top: 50%;
        background: rgba(0, 0, 0, 0.5);
        left: 50%;
        width: 100%;
        transform: translate(-50%, -50%);
      }

      .portMenu {
        ul {
          border-bottom: 1px solid #ddd;
          overflow-x: auto;
          overflow-y: hidden;
        }
      }

      .itemPortMenu {
        box-shadow: none;
        background: transparent;
        border: none;
        border-bottom: 4px solid transparent;
        border-radius: 0;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 0.75rem;
        color: #666;
        padding: 8px 0px;
        height: auto;
        margin: 0 12px;
        &:hover {
          color: #333;
          border-color: #eee;
        }

        i {
          // width: 22px;
          // height: 22px;
          // align-items: center;
          // justify-content: center;
          // font-size: 10px;
          // background: #eee;
          // border-radius: 6px;
          // display: inline-flex;
        }
        &.--active {
          color: var(--color-primary);
          border-color: var(--color-primary);
          i {
            // background: #fff;
            // border: 1px solid var(--color-primary);
          }
        }
      }

      @media (max-width: 768px) {
        .--content {
          padding-top: 30px;
        }

        .--logo {
          position: relative;
          top: unset;
          display: flex;
          justify-content: center;
        }
      }
    }

    &.headerStyle-3 {
      background: #000;
      .--img {
        height: 200px;
        opacity: 0.5;
      }
      .portInfo {
        position: relative;
      }

      .portProfile {
        width: 100%;
        border-radius: 8px;
        box-shadow: 0 12px 24px rgb(0 0 0 / 8%);
        top: 70px;
        position: relative;
        flex-flow: column;
        overflow: hidden;
        padding: 0 0 1rem 0;
        background: #fff;

        .--name {
          small {
            display: block;
          }
        }

        .--smallCover {
          width: 100%;
          height: auto;
        }

        .--avatar {
          width: 90px;
          height: 90px;
          margin-top: -45px;
        }

        .--logo {
          left: 50%;
          transform: translate(-50%, 0);
          top: 30px;
        }

        .--info {
          text-align: center;
          padding: 0 16px;
          width: 100%;
        }

        .--bio {
          text-align: initial;
        }

        .--wrapper {
          width: 100%;
        }
      }

      .portContact {
        margin: 8px 0 12px;
        padding: 0.75rem 0;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        padding: 1rem 0;
        ul {
        }
        li {
          margin-left: 0;
          padding: 2px 0 2px 0rem;
          a {
            display: flex;
            align-items: center;
            color: #858381;
            text-transform: uppercase;
            i {
              background: transparent;
              color: inherit;
              border: 1px solid transparent;
              border-radius: 0;
              margin-right: 1rem;
            }
            span {
              font-size: 0.72rem;
            }
            &:hover {
              i {
                border-color: #858381;
              }
            }
          }
        }
      }

      .portMenu {
        position: relative;
        top: 1rem;
        ul {
          justify-content: flex-end;
          margin-right: -12px;
          flex-wrap: wrap;
          gap: 6px;
        }
      }

      .itemPortMenu {
        padding: 0 10px;
        color: #fff;
        font-weight: 600;
        border-bottom: 2.5px solid transparent;
        border: none;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.075);
        backdrop-filter: blur(10px);
        &:hover {
          // color: #fff;
          background: rgba(255, 255, 255, 0.3);
          // backdrop-filter: blur(10px);
        }
        &.--active {
          background: var(--color-primary);
          border-radius: 10px;
          color: #fff;
        }
      }

      .--content {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        .container {
          height: 100%;
        }
      }

      @media (max-width: 768px) {
        // .--content{
        //     position: relative;
        //     top: unset;
        //     left: unset;
        // }
        .--logo {
          position: relative;
          top: 0;
          margin: 1rem auto 2rem;
          text-align: center;
        }
        .portProfile {
          // height: auto;
          // align-items: center !important;
          // width: 100%;
          // display: flex !important;
          // flex-flow: column;
          // padding: 16px;
          top: 0;

          .--logo {
            position: relative;
            top: unset;
            transform: none;
            left: unset;
            margin-bottom: 16px;
          }
        }

        .portMenu {
          top: 0;
          margin: 1.5rem 0 0;

          ul {
            flex-wrap: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
            padding-bottom: 1rem;
            justify-content: flex-start;
          }
        }

        .--img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .--content {
          position: relative;
          top: unset;
          left: unset;
          height: auto;
        }
      }
    }
  }
`;

export const FooterWrapper = styled.div`
  .portFooter {
    width: 100%;
    text-align: center;
    position: relative;
    padding-bottom: 0.5rem;
    background: #000;

    // &::after {
    //   content: '';
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   width: 100%;
    //   height: 100%;
    //   background: linear-gradient(0deg, rgb(0 0 0 / 40%), rgba(0, 0, 0, 0.8));
    // }

    .--img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0.5;
    }

    .--profile {
      position: relative;
      z-index: 2;
      color: #fff;
    }

    .--name {
      small {
        margin-left: 0.5rem;
        opacity: 0.75;
      }
    }

    .--avatar {
      width: 60px;
      height: 60px;
      border: 2px solid #fff;
      border-radius: 100%;
      overflow: hidden;
      margin: 0 auto 1rem;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .--name {
      margin-bottom: 0.25rem;
    }

    .--locale {
      i {
        margin-right: 0.25rem;
      }
    }

    .--flag {
    }
    &.footerStyle-1 {
      .--profile {
        top: -30px;
      }
    }
    &.footerStyle-2 {
      .--profile {
        display: flex;
        align-items: center;
        padding: 1.5rem 0 0.5rem;
        justify-content: center;
      }
      .--avatar {
        margin: 0 12px 0 0;
      }
      .--profileTxt {
        display: block;
        text-align: left;
      }
    }

    &.footerStyle-3 {
      .--profile {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--color-primary);
        color: var(--color-secondary);
        width: max-content;
        padding: 0.75rem 1.5rem 0.75rem 0.75rem;
        border-radius: 100px;
        margin: 0 auto 0;
        top: -24px;
        box-shadow: 0 8px 16px rgb(0 0 0 / 50%);
      }
      .--avatar {
        margin: 0 12px 0 0;
        border-color: transparent !important;
      }
      .--profileTxt {
        display: block;
        text-align: left;
      }
    }
  }
`;

export const CollectionWrapper = styled.div`
  margin: 2rem 0 6rem;
  flex: 1;

  .portPage {
    .--intro {
      text-align: center;
      margin-bottom: 2.5rem;
      justify-content: center;
    }

    .--wrapper {
      max-width: 72%;
    }

    .--title {
      // color: var(--color-primary);
    }

    .--desc {
      font-size: 0.85rem;
      color: #666;
      // text-align: justify;
    }

    .--gallery {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      align-items: flex-start;
      align-items: stretch;
    }
    @media (max-width: 768px) {
      .--gallery {
        gap: 8px;
      }
      .--wrapper {
        max-width: none;
        width: 100%;
        text-align: left;
      }
    }
  }
  &.header-style-4 {
    background: #fff;
    position: relative;
    margin: 76vh 0 0 0;
    padding: 2rem 0 6rem;
    .portInfo {
      border: 1px solid #ddd;
      border-left: none;
      margin-top: -10rem;
      background: #fff;
      padding: 0 2rem 0 4rem;
      height: max-content;
      min-height: 460px;
    }
    .portProfile {
      padding: 2rem 0;
      .--avatar {
        border: none;
        border-radius: 0;
        width: 100px;
        height: 100px;
      }
    }
    .portPage {
      // border-top: 1px solid #ddd;
      padding: 0 4rem;
      .--intro {
        text-align: left;
        justify-content: flex-start;
      }
    }
    .portContact {
      padding: 1rem 0;
      ul {
      }
      li {
        margin-left: 0;
        padding: 2px 0 2px 1rem;
        a {
          display: flex;
          align-items: center;
          color: #858381;
          text-transform: uppercase;
          i {
            background: transparent;
            color: inherit;
            border: 1px solid transparent;
            border-radius: 0;
            margin-right: 1rem;
          }
          span {
            font-size: 0.72rem;
          }
          &:hover {
            i {
              border-color: #858381;
            }
          }
        }
      }
    }
    .portMenu {
      margin-bottom: 2rem;
      ul {
        // gap: 8px;
        // margin-left: -16px;
        flex-wrap: wrap;
        gap: 4px;
      }
    }
    .itemPortMenu {
      padding: 0 1rem;
      text-transform: uppercase;
      font-size: 0.8rem;
      border: none;
      box-shadow: none;
      border-radius: 0;
      letter-spacing: 0.5px;
      color: #666;
      position: relative;
      .--portMenuTitle,
      i {
        position: relative;
        z-index: 1;
      }

      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
        z-index: 0;
        left: 0;
        transition: var(--transition-regular);
        border: 1px solid transparent;
      }
      &:hover {
        &:after {
          // background: #eee;
          border-color: #ddd;
        }
      }
      &.--active {
        background: transparent;
        color: var(--color-secondary);
        &:after {
          background: var(--color-primary);
          border-color: var(--color-primary);
        }
      }
    }
    ${ProjectItemWrapper} {
      width: calc(25% - 14px);
      &.projectStyle-3 {
        width: calc(50% - 14px);
      }
      &.projectStyle-4 {
        height: 220px;
        width: calc(33.333% - 12px);
      }
    }
    @media (min-width: 1400px) {
      ${ProjectItemWrapper} {
        // width: calc(25% - 14px);
        &.projectStyle-3 {
          width: calc(50% - 14px);
        }
        &.projectStyle-4 {
          height: 260px;
          width: calc(33.333% - 12px);
        }
      }
    }
    @media (max-width: 768px) {
      padding: 0;
      margin-top: 300px;

      .portInfo {
        margin: 0;
        min-height: auto;
        border: none;
        padding: 0;
      }
      .portProfile {
        padding: 2rem 1rem;
      }
      .portPage {
        padding: 0 1rem 4rem;
      }
      .portMenu {
        width: calc(100% + 2rem);
        margin-left: -1rem;
        overflow-x: auto;
        overflow-y: hidden;
        padding: 0 0 0 1rem;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
      }
      .itemPortMenu {
        &:hover {
          &:after {
            border-color: #333;
          }
        }
      }
      .portContact {
        li {
          padding-left: 0;
        }
      }
    }
  }
  &.header-style-3 {
    .portPage {
      padding-left: 1rem;
      .--intro {
        text-align: left;
        justify-content: flex-start;
      }
      .--wrapper {
        max-width: none;
      }
    }
    ${ProjectItemWrapper} {
      width: calc(25% - 14px);
      &.projectStyle-3 {
        width: calc(50% - 14px);
      }
      &.projectStyle-4 {
        height: 220px;
        width: calc(33.333% - 12px);
      }
    }
    @media (max-width: 768px) {
      .portPage {
        padding-left: 0;
      }
    }
  }
`;

export const HomeWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .portProfile {
    h1 {
      font-size: 1.25rem;
    }
  }

  .portBanner {
    .--img {
      width: 100%;
      object-fit: cover;
    }

    .--logo {
      position: absolute;
      top: 1rem;

      img {
        max-width: 120px;
      }
    }

    .portMenu {
      li {
      }
    }
  }

  .portProfile {
    .--name {
      small {
        font-weight: initial;
        color: inherit;
        opacity: 0.5;
        margin-left: 6px;
        font-size: 0.85rem;
      }
    }
  }

  .portProfile {
    .--wrapper {
      display: flex;
    }

    .--avatar {
      width: 154px;
      height: 154px;
      flex: 0 0 auto;
      border-radius: 50%;
      border: 4px solid #fff;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .--name {
    }

    .--locale {
      margin: 0.25rem 0 0.5rem;
      font-size: 0.85rem;
      // color: #707070;
      opacity: 0.75;
      i {
        margin-right: 0.25rem;
      }
    }

    .--bio {
    }

    .--bioToggler {
      display: block;
      text-decoration: underline;
      cursor: pointer;
      color: var(--color-primary);
    }
  }

  .portContact {
    ul {
    }

    li {
      margin-left: 0.5rem;

      &:first-child {
        margin-left: 0;
      }
    }

    a {
    }

    i {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      transition: var(--transition-smooth);
      &:hover {
        transform: scale(1.1);
        background: #fff;
        color: var(--color-primary);
      }
    }
  }

  .itemPortMenu {
    height: 36px;
    line-height: 36px;
    padding: 0 16px;
    border: 1px solid #ddd;
    border-radius: 25px;
    cursor: pointer;
    transition: var(--transition-regular);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    flex: 0 0 auto;
    // margin-right: 0.5rem;
    display: inline-flex;
    align-items: center;
    .--portMenuTitle {
      color: inherit;
      font-size: inherit;
      font-weight: inherit;
      margin: 0;
    }
    i {
      margin-left: 0.5rem;
      font-size: 0.7rem;
    }

    &:hover {
      background: #eee;
      border-color: transparent;
      box-shadow: none;
    }

    &.--active {
      background: var(--color-primary);
      color: #fff;
      border-color: transparent;
    }
  }

  &.dark-mode {
    background: var(--color-dark);
    color: var(--color-text);

    .portProfile {
      .--avatar {
        border-color: var(--color-dark);
      }
    }

    .portPage {
      .--desc {
        color: var(--color-grey-3);
      }
    }

    .portBanner {
      &.headerStyle-1 .portMenu ul {
        border-color: var(--color-grey-4);
      }
      &.headerStyle-2 {
        .portMenu ul {
          border-color: var(--color-grey-4);
        }
        .portProfile .--avatar {
          border-color: #fff;
        }
        .itemPortMenu {
          color: var(--color-grey-3);
          background: transparent !important;
          &:hover {
            color: var(--color-grey-1);
          }
          &.--active {
            border-color: var(--color-primary);
            color: var(--color-primary);
          }
        }
      }
      &.headerStyle-3 {
        .portProfile {
          background: var(--color-grey-5);
          color: #fff;
        }
        .portContact {
          border-color: var(--color-grey-4);
          color: #fff;
          li i {
            color: var(--color-grey-1);
            &:hover {
              background: var(--color-grey-4);
            }
          }
        }
      }
    }

    .portFooter {
      .--avatar {
        border-color: var(--color-dark);
      }
    }

    .header-style-4 {
      background: var(--color-grey-5);
      .portInfo {
        background: var(--color-grey-5);
        border-color: var(--color-grey-4);
      }
      .portPage {
        // background: var(--color-grey-5);
        border-color: var(--color-grey-4);
      }
      .portContact {
        a {
          color: var(--color-grey-2);
          &:hover {
            color: var(--color-grey-1);
          }
        }
      }
      .itemPortMenu {
        color: var(--color-grey-2);
        &:after {
          background: transparent;
        }
        &:hover {
          color: var(--color-grey-1);
        }
      }
    }

    .itemPortMenu {
      border-color: var(--color-grey-4);
      &:hover {
        background: var(--color-grey-5);
        // color: var(--color-dark);
        border-color: var(_-color-grey-3);
      }
      &.--active {
        background: var(--color-primary);
        color: var(--color-secondary);
        border-color: var(--color-primary);
      }
    }

    ${ProjectItemWrapper} {
      // color: var(--color-dark);
      &.projectStyle-1 {
        background: var(--color-grey-5);
        color: #fff;
        border-color: transparent;
        &:hover {
          background: var(--color-grey-4);
        }
      }

      &.projectStyle-2 {
        // opacity: 0.5;
        color: var(--color-grey-1);
        // background: var(--color-grey-5);
        .--pjInfo {
          background: var(--color-grey-5);
          border-color: transparent;
        }
        .--pjImg {
          border: 1px solid var(--color-grey-4);
        }
        .--pjShortDesc {
          margin: 0;
        }
        &:hover {
          .--pjInfo {
            // border-color: transparent;
            background: var(--color-grey-4);
          }
        }
      }

      &.projectStyle-3 {
        // background: var(--color-gray);
        color: #fff;
        .--shortDesc {
        }
        &:after {
          background: var(--color-grey-5);
        }
        &:hover {
          &:after {
            background: var(--color-grey-4);
            border-color: transparent;
            // border-color: var(--color-grey-1);
          }
        }
      }
    }
  }

  &.light-mode {
    background: var(--color-text);
  }
`;
